<template>
  <transition name="zk-alert-fade">
    <div class="zk-alert" :class="[ typeClass ]" v-show="visible">
      <i class="zk-alert__icon" :class="[ iconClass, isBigIcon ]" v-if="showIcon"></i>
      <div class="zk-alert__content">
        <span class="zk-alert__title" :class="[ isBoldTitle ]" v-if="title">{{ title }}</span>
        <p class="zk-alert__description" v-if="description">{{ description }}</p>
        <i class="zk-alert__closebtn" :class="{ 'is-customed': closeText !== '', 'zk-icon-close': closeText === '' }" v-show="closable" @click="close()">{{closeText}}</i>
      </div>
    </div>
  </transition>
</template>

<script type="text/babel">
  const TYPE_CLASSES_MAP = {
    'success': 'zk-icon-circle-check',
    'warning': 'zk-icon-warning',
    'error': 'zk-icon-circle-cross'
  }
  export default {
    name: 'zk-alert',
    props: {
      title: {
        type: String,
        default: '',
        required: true
      },
      description: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'info'
      },
      closable: {
        type: Boolean,
        default: true
      },
      closeText: {
        type: String,
        default: ''
      },
      showIcon: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        visible: true
      }
    },

    methods: {
      close() {
        this.visible = false
        this.$emit('close')
      }
    },

    computed: {
      typeClass() {
        return `zk-alert--${this.type}`
      },

      iconClass() {
        return TYPE_CLASSES_MAP[this.type] || 'zk-icon-information'
      },

      isBigIcon() {
        return this.description ? 'is-big' : ''
      },

      isBoldTitle() {
        return this.description ? 'is-bold' : ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// alert.vue?b8f925a4